import React from "react";
import { Link } from "react-router-dom";
import { Col } from "reactstrap";

import styles from "./QuoteButton.module.scss";

function Button({ icon, text, link, visibility, arrow, routed }) {
  if (routed) {
    return (
      <Col className={`col-md ${visibility} d-flex`} sm={12}>
        <Link
          className={`${styles["btn"]} ${
            arrow ? styles["arrow"] : ""
          } btn btn-block text-left text-md-center`}
          to={link}
        >
          <i className={`${icon.type} ${icon.icon}`}></i>
          <p className="m-0">{text}</p>
        </Link>
      </Col>
    );
  }

  return (
    <Col className="col-md d-md-none" sm={12}>
      <a className={`${styles["btn"]} btn btn-block`} href={link}>
        <i className={`${icon.type} ${icon.icon}`}></i>
        <p className="m-0">{text}</p>
      </a>
    </Col>
  );
}

export default Button;
